/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { InAppMessageAttribute } from 'cio/app-models/in-app/in-app-message';
import { later } from '@ember/runloop';

interface RuleDefinitionArgs {
  attribute: InAppMessageAttribute;
  onChange: (name: string, value: string) => unknown;
  onFocus?: () => unknown;
  onBlur?: () => unknown;
}

export default class MessageAttributeEditor extends Component<RuleDefinitionArgs> {
  @tracked isTouched = false;

  get attribute() {
    return this.args.attribute;
  }

  get name() {
    return this.attribute.key;
  }

  get value() {
    return this.attribute.value;
  }

  get showErrors() {
    return this.isTouched && this.attribute.hasErrors;
  }

  get errors() {
    return this.attribute.errors.value;
  }

  @action
  onFocus() {
    this.args.onFocus?.();
  }

  @action
  onBlur() {
    if (!this.isTouched) {
      later(() => {
        this.isTouched = true;
      }, 0);
    }
    this.args.onBlur?.();
  }

  @action
  onChange(value: string) {
    let { key } = this.attribute;
    this.args.onChange(key, value);
  }
}
